'use client';

import { useSyncExternalStore } from 'react';
import { useCookies } from '@packages/shared/src/providers/CookieProvider/CookieProvider';
import { previewModeCookieName, previewModeCookieEnabledValue } from './consts';
import { previewSettingsStore, previewSettingsServerSnapshot } from './previewSettingsStore';

export const usePreviewSettings = () => {
  const { getCookies } = useCookies();
  const isActive = getCookies()[previewModeCookieName] === previewModeCookieEnabledValue;
  const settings = useSyncExternalStore(
    previewSettingsStore.subscribe,
    previewSettingsStore.get,
    previewSettingsServerSnapshot,
  );
  return { isActive, settings };
};
